import React from 'react'
import PropTypes from 'prop-types'
import railsContext from 'lib/selectors/rails-context'
import { useSelector } from 'react-redux'

const Logo = ({ isLoggedIn, showSearchbox, onlyMin, hideUnder }) => {
  const hideOnSmallScreen = !isLoggedIn && showSearchbox
  const noMargin = isLoggedIn && showSearchbox
  const {
    headerProps: { rootPath }
  } = useSelector(railsContext)

  return (
    <a
      href={rootPath}
      className={`item ${onlyMin ? 'min-logo' : 'logo'}${hideOnSmallScreen ? ' hide-under-701-screen' : ''}${
        noMargin ? ' logo-0-margin' : ''
      }${hideUnder ? ` hide-under-${hideUnder}-screen` : ''}`}
      aria-label='logo'
    />
  )
}

Logo.propTypes = {
  isLoggedIn: PropTypes.bool,
  showSearchbox: PropTypes.bool,
  onlyMin: PropTypes.bool,
  hideUnder: PropTypes.number
}

export default Logo
